import { STATIC_IMG_PATH } from "@/views/zhiji/js/common/constants.js";
import { businessLangs } from "@/components/langSelect/languages.js";
import OperatorColumn from "./components/OperatorColumn";
import StateColumn from "./components/StateColumn.vue";
import similarColumn from "./components/similarColumn";
import i18n from "@/i18n";
import LineBreakColumn from "./components/LineBreakColumn.vue";

export const quesListTable = () => {
    return {
        columns: [
            {
                colId: "check",
                header: "",
                type: "Checkbox",
                width: "37px"
            },
            {
                colId: "questionId",
                header: i18n.t("zhiji.knowlege.tabelCloumn.no"),
                type: "Text",
                width: "12%"
            },
            {
                colId: "standQuestion",
                header: i18n.t("zhiji.knowlege.standQustion"),
                type: "Link",
                width: "19%"
            },
            {
                colId: "language",
                header: i18n.t("zhiji.knowlege.language"),
                type: "Text",
                width: "8%"
            },
            {
                colId: "similarQuestion",
                header: i18n.t("zhiji.knowlege.similarQuestion"),
                type: "Custom",
                width: "8%",
                component: similarColumn
            },
            {
                colId: "creator",
                header: i18n.t("zhiji.knowlege.tabelCloumn.creator"),
                type: "Custom",
                width: "12%",
                component: LineBreakColumn
            },
            {
                colId: "editor",
                header: "最后编辑",
                type: "Custom",
                width: "12%",
                component: LineBreakColumn
            },
            {
                colId: "state",
                header: i18n.t("zhiji.common.status"),
                type: "Custom",
                width: "12%",
                component: StateColumn
            },
            {
                colId: "operator",
                header: i18n.t("zhiji.common.operate"),
                type: "Custom",
                width: "20%",
                component: OperatorColumn
            }
        ],
        allCheckScope: "page",
        pageLength: 10,
        pageLengthRank: [10, 20, 30, 100],
        bottomButtons: [
            {
                id: "delete",
                text: i18n.t("zhiji.common.delete"),
                icon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -94px 0px",
                hoverIcon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -94px -22px"
            },
            {
                id: "online",
                text: i18n.t("zhiji.knowlege.online"),
                icon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -210px 0px",
                hoverIcon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -210px -20px"
            },
            {
                id: "offline",
                text: i18n.t("zhiji.knowlege.offline"),
                icon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -230px 0px",
                hoverIcon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -230px -20px"
            },
            {
                id: "transfer",
                text: i18n.t("zhiji.knowlege.transferTo"),
                icon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -191px 0px",
                hoverIcon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -191px -20px",
                type: "OptionButton",
                options: []
            }
        ]
    };
};

export const statusOptions = () => [
    {
        label: i18n.t("zhiji.common.allStatus"),
        value: "all"
    },
    {
        label: i18n.t("zhiji.knowlege.alreadyOn"),
        value: "online"
    },
    {
        label: i18n.t("zhiji.knowlege.alreadyOff"),
        value: "offline"
    },
    {
        label: i18n.t("zhiji.knowlege.draft"),
        value: "draft"
    }
];

export const creatorOptions = () => [
    {
        label: i18n.t("zhiji.knowlege.allCreator"),
        value: "all"
    }
];

export const questionOptions = () => [
    {
        label: i18n.t("zhiji.knowlege.byStandard"),
        value: "stand"
    },
    {
        label: i18n.t("zhiji.knowlege.bySimilar"),
        value: "extend"
    },
    {
        label: i18n.t("zhiji.knowlege.byAnswer"),
        value: "answer"
    },
    {
        label: i18n.t("zhiji.knowlege.byStandId"),
        value: "questionId"
    },
    {
        label: i18n.t("zhiji.knowlege.byAnswerId"),
        value: "answerId"
    },
    {
        label: i18n.t("zhiji.knowlege.byFormId"),
        value: "formId"
    },
    {
        label: i18n.t("zhiji.knowlege.byStandIdQueryCorrelation"),
        value: "questionIdReverse"
    },
    {
        label: i18n.t("zhiji.knowlege.byParameters"),
        value: "userProfileParam"
    },
    {
        label: i18n.t("zhiji.knowlege.byTags"),
        value: "userProfileTag"
    },
];

export const recommendOptions = () => [
    {
        label: i18n.t("zhiji.knowlege.allStandQues"),
        value: "all"
    },
    {
        label: i18n.t("zhiji.knowlege.hasSimilarQues"),
        value: "similar"
    },
    {
        label: i18n.t("zhiji.knowlege.noSimilarQues"),
        value: "noSimilar"
    }
];

export const conditionOption = () => [
    {
        label: i18n.t("zhiji.knowlege.include"),
        value: "1"
    },
    {
        label: i18n.t("zhiji.knowlege.uninclude"),
        value: "0"
    }
];

export const smallLangOption = () => {
    return [
        {
            label: i18n.t("zhiji.knowlege.smallLang"),
            value: "all"
        },
        ...businessLangs().map(lang => {
            return {
                label: i18n.t(lang.i18nKey),
                value: lang.lang
            };
        })
    ];
};

export const componentsTypeLabels = () => ({
    text: i18n.t("zhiji.knowlege.components.text"),
    image: i18n.t("zhiji.knowlege.components.image"),
    container: i18n.t("zhiji.knowlege.components.container"),
    tip: i18n.t("zhiji.knowlege.components.tip"),
    shortcut_bar: i18n.t("zhiji.knowlege.components.shrtcutBar"),
    video: i18n.t("zhiji.knowlege.components.video"),
    question: i18n.t("zhiji.knowlege.components.question"),
    inner_link: i18n.t("zhiji.knowlege.components.innerLink"),
    link: i18n.t("zhiji.knowlege.components.externalLink"),
    highlight: i18n.t("zhiji.knowlege.components.highLight"),
    hot_questions: i18n.t("zhiji.knowlege.components.hotQuestions"),
    tool: i18n.t("zhiji.knowlege.components.tool"),
    package: i18n.t("zhiji.knowlege.components.package"),
    form: i18n.t("zhiji.knowlege.components.form"),
    portrait: i18n.t("zhiji.knowlege.components.portrait")
});
